// frontend/src/components/common/ImageZoomModal.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { X, ZoomIn, ZoomOut, RotateCcw } from "lucide-react";
import "./ImageZoomModal.css";

const ImageZoomModal = ({
  isOpen,
  onClose,
  imageSrc,
  imageAlt = "Image",
}) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
      return () => {
        document.removeEventListener("keydown", handleEscape);
        document.body.style.overflow = "auto";
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="image-zoom-modal-overlay" onClick={onClose}>
      <div
        className="image-zoom-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="image-zoom-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          <X className="w-6 h-6" />
        </button>

        <TransformWrapper
          initialScale={1}
          minScale={0.5}
          maxScale={5}
          doubleClick={{ mode: "toggle", step: 2 }}
          wheel={{ step: 0.2 }}
          pinch={{ step: 5 }}
          centerOnInit={true}
        >
          {({ zoomIn, zoomOut, resetTransform }) => (
            <>
              <TransformComponent
                wrapperClass="image-zoom-modal-image-container"
                contentClass="image-zoom-modal-image-content"
              >
                <img src={imageSrc} alt={imageAlt} />
              </TransformComponent>

              <div className="image-zoom-controls">
                <button
                  className="image-zoom-btn"
                  onClick={() => zoomOut()}
                  aria-label="Zoom out"
                >
                  <ZoomOut className="w-5 h-5" />
                </button>
                <button
                  className="image-zoom-btn"
                  onClick={() => resetTransform()}
                  aria-label="Reset zoom"
                >
                  <RotateCcw className="w-5 h-5" />
                </button>
                <button
                  className="image-zoom-btn"
                  onClick={() => zoomIn()}
                  aria-label="Zoom in"
                >
                  <ZoomIn className="w-5 h-5" />
                </button>
              </div>
            </>
          )}
        </TransformWrapper>
      </div>
    </div>,
    document.body
  );
};

export default ImageZoomModal;
